import { UAPI_URL_CONFIG } from "../config"



//#region Api Calling For NotifiacationConfiguartion GetUserBysite
// export const getRegisteredUsers = async (siteIds, pageNumber, searchText) => {
//     const requestOptions = {
//         method: "GET",
//         headers: {
//             "Content-Type": "application/json",
//             "authcode": localStorage.getItem('authCode'),
//             "Authorization": "Bearer " + localStorage.getItem('authToken')
//         }
//     }
//     let url = UAPI_URL_CONFIG + "notification/getUserBySite?siteIds=" + siteIds + "&pageNumber=" + pageNumber + "&searchText=" + searchText;
//     //let url = UAPI_URL_CONFIG + "escalation/getUserBySite?siteIds=" + siteIds + "&pageNumber=" + pageNumber + "&searchText=" + searchText;
//     return await fetch(url, requestOptions)
//         .then(res => res.json())
//         .then(data => {
//             return data;
//         })
//         .catch(err => console.log(err));
// }
//#endregion

//#region Api Calling for NotificationConfiguartion Mentions(PlaceHolder)
export const getMentionsList = async () => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        }
    }
    let url = UAPI_URL_CONFIG + "notification/mentionValue/";
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => { 
            return data;
        })
        .catch(err => console.log(err));
}
//#endregion

//#region Api Calling for Get Notification
export const getEscalations = async () => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        }
    }
    // let url = UAPI_URL_CONFIG + "notification/getAllNotificationConfiguration?UserId=" + localStorage.getItem('UserID')
    let url = UAPI_URL_CONFIG + "escalation/getAllEscalation/?UserID=" + localStorage.getItem('UserID')
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => console.log(err));
}
//#endregion

//#region Api Calling for Add Notification
export const addEscalations = async (obj) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        },
        body: JSON.stringify(obj)
    }
    // let url = UAPI_URL_CONFIG + "notification/addNotificationConfiguration"
    let url = UAPI_URL_CONFIG + "escalation/addEscalation"
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => console.log(err))
}
//#endregion

//#region Api Calling For Update Notification 
export const updateEscalations = async (obj) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        },
        body: JSON.stringify(obj)
    }
    // let url = UAPI_URL_CONFIG + "escalation/addEscalation";
    let url = UAPI_URL_CONFIG + "escalation/updateEscalation"
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => console.log(err))
}
//#endregion

//#region Api Calling for GetNotificationById 
    
export const getEscalationById = async (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        }
    }
    // let url = UAPI_URL_CONFIG + `notification/getAllNotificationConfigurationById?UserID=${localStorage.getItem('UserID')}&NotificationConfigurationID=${id}`;
    // let url = UAPI_URL_CONFIG +  `escalation/getAllEscalation/?UserID=${localStorage.getItem('UserID')}&EscalationConfigID=${id}`
    let url =UAPI_URL_CONFIG + "escalation/getEscalationById/?UserID=" + localStorage.getItem('UserID') + "&EscalationConfigID=" + id
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => console.log(err))
}
//#endregion

//#region Api Calling for DeleteNotification
export const removeEscalation = async (EscalationConfigID) => {
    const requestOptions = {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        },
    }
    // let url = BASE_CORE_URL + "NotificationConfiguration/Delete";
    
    let url = UAPI_URL_CONFIG + `escalation/deleteEscalation/?EscalationConfigID=${EscalationConfigID}`;

    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => console.log(err))
}
//#endregion

export const getEmergencyContactList = async (userId,siteIds) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        }
    }
    // let url = UAPI_URL_CONFIG + "notification/getEmergencyContactBySite?userId=" + userId + "&siteIds=" + siteIds;
    let url = UAPI_URL_CONFIG + "escalation/getEmergencyContactBySite?userId=" + userId + "&siteIds=" + siteIds;
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => console.log(err));
}